const getRoles = (userData: { roles : { key: string}[]}) => userData.roles.map((role: { key: string}) => role.key);

export default getRoles;
